var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPassGradient = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 800,
  height: 200,
  viewBox: "0 0 800 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 800,
  height: 200,
  fill: "url(#gradient-fill)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "gradient-fill",
  x1: 0,
  y1: 0,
  x2: 800,
  y2: 0,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#224b87"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14285714285714285,
  stopColor: "#255192"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2857142857142857,
  stopColor: "#27579d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42857142857142855,
  stopColor: "#2a5da8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5714285714285714,
  stopColor: "#2d64b3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7142857142857142,
  stopColor: "#306abf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8571428571428571,
  stopColor: "#3371ca"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3677d6"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPassGradient);
export default ForwardRef;